var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tracks-list',{attrs:{"tracks":_vm.allTracks,"loading":_vm.loading},on:{"play":function($event){return _vm.setPlaylist(_vm.allTracks)}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1372ca06","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tracks/AllTracksList.vue
// module id = 1039
// module chunks = 4